'use strict';

var processInclude = require('core/util');

$(document).ready(function () {
    processInclude(require('core/search/search'));
    processInclude(require('core/product/compare'));
    processInclude(require('core/product/wishlistHeart'));
    processInclude(require('./search/searchVariation'));
});
